'use strict';

var React = require('react');

var SvgPackageFilledIcon = function SvgPackageFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 15.975c.31-.316.5-.748.5-1.225v-6.894a2.75 2.75 0 0 0-.462-1.526l-1.219-1.828a2.25 2.25 0 0 0-1.872-1.002h-5.796a2.25 2.25 0 0 0-1.836.95l-1.31 1.847a2.75 2.75 0 0 0-.505 1.59v6.863c0 .477.19.91.5 1.225v.025h.025c.316.31.748.5 1.225.5h9.5c.477 0 .91-.19 1.225-.5h.025v-.025Zm-9.461-10.659a.75.75 0 0 1 .612-.316h2.099v1.5h-3.55l.839-1.184Zm4.211 1.184h3.599l-.778-1.166a.75.75 0 0 0-.624-.334h-2.197v1.5Zm-4 3.75a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5v-2.5Z"
  }));
};
SvgPackageFilledIcon.displayName = "PackageFilledIcon";

exports.SvgPackageFilledIcon = SvgPackageFilledIcon;
